<script>
import axios from 'axios'
import Cookies from 'js-cookie'
import { validationMixin } from 'vuelidate'
import { required, email, numeric, between, requiredIf } from 'vuelidate/lib/validators'
import moment from 'moment'
import supportsType from './supports-type'

let thisYear = new Date().getFullYear()


export default {
  name: 'MissingChildIntakeForm',

  mixins: [validationMixin],

  props: {
    action: {
      type: String,
      required: true,
    },
    referrer: {
      type: String,
      default: '',
    },
    lang: {
      type: String,
      default: 'en',
    }
  },
  data() {
    return {
      state: 'form',
      showSuccess: false,

      missingtypes_data: {},
      relationship_to_child_data: {},
      countries_data: {},
      provinces_data: {},

      supportsDate: supportsType(document.getElementById('last_seen_date')),
      supportsTime: supportsType(document.getElementById('last_seen_time')),
      dayMax: 31,

      children: [{
        first_name: '',
        last_name: '',
        age: '',
        has_medical_problems: '',
        medical_problems: ''
      }],

      child_last_seen: {
        date: '',
        time: '',

        year: thisYear,
        month: '',
        day: '',
      },

      anyone_seen_child: '',
      anyone_seen_child: '',
      anyone_seen_child_details: '',
      anyone_seen_child_details: '',
      child_details: '',
      any_other_info: '',
      have_police_incident_number: '',
      police_agency: '',
      caller_incident_number: '',
      officers_name: '',

      caller_first_name: '',
      caller_last_name: '',
      caller_phone: '',
      caller_email: '',
      relationship_to_child_id: '',
      relationship_to_child_id: '',
      relationship_to_child_other: '',
      relationship_to_child_other: '',
      country_of_residence_id: '',
      province_of_residence_id: '',
      allow_province: true,
      caller_is_guardian: '',
      guardian_first_name: '',
      guardian_last_name: '',
      guardian_phone: '',
      become_aware: '',

      missingtypes_id: '',

      errors: {},
    }
  },

  validations() {
    let v = {
      child_last_seen: {
        date: { },
        time: { required },

        year: { },
        month: { },
        day: { },
      },

      anyone_seen_child: { required },
      anyone_seen_child_details: { },
      child_details: { required },
      any_other_info: { },
      have_police_incident_number: { required },
      police_agency: { },
      caller_incident_number: { },
      officers_name: { },

      caller_first_name: { required },
      caller_last_name: { required },
      caller_phone: { },
      caller_email: { email, required },
      relationship_to_child_id: { required },
      relationship_to_child_other: { },
      country_of_residence_id: { required },
      province_of_residence_id: { },
      caller_is_guardian: { required },
      guardian_first_name: { },
      guardian_last_name: { },
      guardian_phone: { },
      become_aware: { },

      missingtypes_id: { required },

      // captcha: { },
    }

    if (this.supportsDate) {
      v.child_last_seen.date = { required }
    } else {
      v.child_last_seen.year = { required }
      v.child_last_seen.month = { required }
      v.child_last_seen.day = {
        required,
        numeric,
        between: between(0, parseInt(this.dayMax))
      }
    }

    if (this.anyone_seen_child === '1') {
      v.anyone_seen_child_details = { required }
    }

    if (this.relationship_to_child_id == '4') {
      v.relationship_to_child_other = { required }
    }

    if (this.country_of_residence_id == '1' || this.country_of_residence_id == '236') {
      v.province_of_residence_id = { required }
    }

    return v
  },

  computed: {
    // showForm() { return this.state === 'form' },
    // showProcessing() { return this.state === 'processing' },
    // showSuccess() { return this.state === 'success' },
    showError() { return this.state === 'error' },
  },

  mounted() {
    window._paq.push(['FormAnalytics::scanForForms', document.getElementById('missing-child-intake-form')])

    if (!this.supportsDate) {
      // use fallback fields instead
      const yearInput = document.getElementById('child_last_seen.year')
      const monthInput = document.getElementById('child_last_seen.month')
      const dayInput = document.getElementById('child_last_seen.day')

      this.populateYears(yearInput)

      monthInput.addEventListener('change', (e) => {
        this.manageDays(dayInput, yearInput.value, monthInput.value)
      })
    }

    axios.get('/api/missingtypes/')
      .then(response => {
        this.missingtypes_data = response['data']
      })
      .catch(error => {
        console.log(error)
      })

    axios.get('/api/relationship/')
      .then(response => {
        this.relationship_to_child_data = response['data']
      })
      .catch(error => {
        console.log(error)
      })

    axios.get('/api/countries/')
      .then(response => {
        this.countries_data = response['data']
        this.sortCountries(this.countries_data)
      })
      .catch(error => {
        console.log(error)
      })
  },

  methods: {
    submit() {
      var isvalid = 1

      //Have to run through all the children first.
      for (var i in this.$refs.children) {
        var child = this.$refs.children[i]
        if (child.$v.$invalid) {
          // Child has errors
          child.$v.$touch()
          isvalid = 0
        }
      }

      //Now run through the rest of the form.
      if (this.$v.$invalid) {
        // Form has errors
        this.$v.$touch()
        isvalid = 0
      }

      if (isvalid == 0) {
        this.$nextTick(() => this.scrollToError())
        return
      }

      let captcha = this.$refs.captcha
      let payload = {...this.$data}

      if (captcha) {
        payload.captcha_0 = captcha.captchaKey
        payload.captcha_1 = captcha.response
      }

      let dateString = this.$data.child_last_seen.date
      let timeString = this.$data.child_last_seen.time

      if (!this.supportsDate) {
        let day = this.$data.child_last_seen.day
        if (day.length === 1) {
          day = `0${day}`
        }
        dateString = `${this.$data.child_last_seen.year}-${this.$data.child_last_seen.month}-${day}`
      }

      let dd = moment(dateString + ' ' + timeString).utc().format()

      payload['child_last_seen'] = dd

      this.state = 'form'

      const csrftoken = Cookies.get('csrftoken')
      axios.post(this.action, payload, {'headers': { 'X-CSRFToken': csrftoken }}).then(
        this.success,
        this.error
      )
    },

    error(error) {
      this.errors = error.response.data.errors
      if (this.$refs.captcha) {
        this.$refs.captcha.refresh()
      }

      if (this.errors.html_encoding_length_issue) {
        document.getElementById('open_encoding_modal').click();
      }

      this.state = 'error'
    },

    success(response) {
      this.child_last_seen.date = ''
      this.child_last_seen.time = ''
      this.anyone_seen_child = ''
      this.anyone_seen_child_details = ''
      this.child_details = ''
      this.any_other_info = ''
      this.have_police_incident_number = ''
      this.police_agency = ''
      this.caller_incident_number = ''
      this.officers_name = ''
      this.caller_first_name = ''
      this.caller_last_name = ''
      this.caller_phone = ''
      this.caller_email = ''
      this.relationship_to_child = ''
      this.relationship_to_child_other = ''
      this.caller_is_guardian = ''
      this.guardian_first_name = ''
      this.guardian_last_name = ''
      this.guardian_phone = ''
      this.become_aware = ''

      this.$nextTick(function() { this.showSuccess = true })
      this.$refs.captcha.refresh()

      window.scrollTo(0,0) //Go back to the top of the page
    },

    getFocusableEls() {
      const focusables = this.$el.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]')
      return Array.prototype.slice.call(focusables)
    },

    scrollToError() {
      const errorEls = [...this.$el.querySelectorAll('.error')]
      const firstError = errorEls.filter(el => el.tagName.toUpperCase() !== 'LEGEND')[0]

      if (firstError) {
        const focusTarget = this.getFocusableEls().filter(formEl => firstError.contains(formEl))
        focusTarget[0].focus()
      }
    },

    populateYears(el) {
      const date = new Date()
      const year = date.getFullYear()
      let first_iter = true

      for (let i = 0; i <= 100; i++) {
        let option = document.createElement('option')
        option.value = year - i
        option.textContent = year - i

        if (first_iter) {
          option.setAttribute('selected', 'selected')
          first_iter = false
        }

        el.appendChild(option)
      }
    },

    manageDays(el, yearValue, monthValue) {
      // replacing <option> els breaks the ability to reselect days in some versions of Firefox,
      // so these can instead be managed with toggling the disabled attr

      let dayNum
      let months31 = ['01', '03', '05', '07', '08', '10', '12']
      let months30 = ['04', '06', '09', '11']

      if (months31.includes(monthValue)) {
        dayNum = 31
      } else if (months30.includes(monthValue)) {
        dayNum = 30
      } else {
        let leap = (yearValue % 4 === 0 && yearValue % 100 !== 0) || yearValue % 400 === 0
        dayNum = leap ? 29 : 28
      }

      this.dayMax = dayNum
    },

    addChild() {
      this.children.push({
        first_name: '',
        last_name: '',
        age: '',
        has_medical_problems: '',
        medical_problems: ''
      })
    },

    removeChild() {
      if (this.children.length > 1) {
        this.children.pop()
      }
    },

    sortCountries(list) {
      list.sort((a, b) => {

        // put Canada on top
        if (a.country_code == "CA") {
          return -1
        } else if (b.country_code == "CA") {
          return 1
        }

        // put United States second to CA
        if (a.country_code == "US") {
          return b.country_code == "CA" ? 1 : -1;
        } else if (b.country_code == "US") {
          return a.country_code == "CA" ? -1 : 1;
        }

        // everything else
        const nameA = this.lang == 'en' ? a.country_name.toUpperCase() : a.country_name_fr.toUpperCase();
        const nameB = this.lang == 'en' ? b.country_name.toUpperCase() : b.country_name_fr.toUpperCase();
        if (nameA < nameB) {
          return -1; // a comes before b
        }
        if (nameA > nameB) {
          return 1; // b comes before a
        }
        return 0; // names are equal
      });
    }

  },

  watch: {
    country_of_residence_id() {
      if (this.country_of_residence_id == 1 || this.country_of_residence_id == 236) {
        this.allow_province = true;
        axios.get('/api/provinces/?country_id=' + this.country_of_residence_id)
            .then(response => {
              this.provinces_data = response['data']
            })
            .catch(error => {
              console.log(error)
            })
        this.allow_province = true;
      } else {
        this.allow_province = false;
      }
      this.province_of_residence_id = '';
    }
  },
}
</script>



// WEBPACK FOOTER //
// js/MissingChildIntakeForm.vue